<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  beforeCreate() {
    console.log("created");
    this.$store.dispatch("setupAxios");
  }
};
</script>

<style lang="scss">
//@import "~materialize-css/dist/css/materialize.min.css";
@import "../Assets/styles/index.scss";
html {
  font-family: SF Pro Display, SF Pro Icons, Helvetica Neue, Helvetica, Arial,
    sans-serif;
}
</style>
